/**
 *  @class
 *  @function MultiRow
 */
if (!customElements.get('multi-row')) {
  // Below this width the pinned-card stack is disabled: mobile rows lay the
  // image out *below* the copy, so a pinned card only ever showed its heading
  // strip and the image stayed under the fold until the next card covered it.
  const STACK_MIN_WIDTH = 768;

  class MultiRow extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.container = this.querySelector('.multi-row--inner');
      this.rows = Array.from(this.querySelectorAll('.multi-row--row'));
      this.spacer = 100;
      this.tl = gsap.timeline();
      this.triggers = [];

      this.mediaQuery = window.matchMedia(`(min-width: ${STACK_MIN_WIDTH}px)`);

      this.refresh = this.refresh.bind(this);
      this.refresh();

      this.mediaQuery.addEventListener('change', this.refresh);
      window.addEventListener('resize', this.refresh);
      document.fonts.ready.then(this.refresh);

      // Watchdog: some browsers (and device emulation) don't reliably fire
      // `resize` / matchMedia `change` when the viewport crosses the
      // breakpoint. Only acts when the stacked/unstacked state is actually
      // out of date, so the min-height initCards() sets can't loop it.
      this.resizeObserver = new ResizeObserver(() => {
        if (this.stackEnabled !== this.isStacked) {
          this.refresh();
        }
      });
      this.resizeObserver.observe(document.documentElement);
    }
    disconnectedCallback() {
      this.mediaQuery?.removeEventListener('change', this.refresh);
      window.removeEventListener('resize', this.refresh);
      this.resizeObserver?.disconnect();
      this.teardownScroll();
    }
    get stackEnabled() {
      return this.mediaQuery.matches;
    }
    get isStacked() {
      return this.triggers.length > 0;
    }
    refresh() {
      if (this.stackEnabled) {
        this.classList.remove('multi-row--unstacked');
        this.initCards();
        if (!this.triggers.length) {
          this.setupScroll();
        }
      } else if (this.isStacked || !this.classList.contains('multi-row--unstacked')) {
        this.teardownScroll();
        this.classList.add('multi-row--unstacked');
      }
    }
    teardownScroll() {
      this.triggers.forEach((trigger) => trigger.kill());
      this.triggers = [];
      // Drop the min-height reserved for the pinned stack and any inline
      // transforms GSAP left on the rows.
      gsap.set(this.container, { clearProps: 'minHeight' });
      this.rows.forEach((row) => {
        gsap.set(row, { clearProps: 'all' });
        delete row.dataset.offset;
      });
    }
    initCards() {
      this.totalOffset = 0;
      this.totalHeight = 0;
      let property = gsap.getProperty('html', '--header-height');

      this.rows.forEach((row, index) => {

        if (index > 0) {
          this.totalOffset += row.querySelector('.multi-row--content-heading').offsetHeight;
          row.dataset.offset = this.totalOffset;
        } else {
          this.totalOffset = 0 + property;
          row.dataset.offset = this.totalOffset;
        }
        this.totalHeight += row.offsetHeight;
      });

      gsap.set(this.container, { minHeight: this.totalHeight + this.totalOffset + ((this.rows.length - 1) * property) });
    }
    setupScroll() {

      let getOffset = (row) => {
        return row.dataset.offset;
      };
      this.rows.forEach((row, index) => {
        this.triggers.push(ScrollTrigger.create({
          trigger: row,
          start: `top top+=${getOffset(row)}`,
          endTrigger: this.container,
          end: `bottom bottom`,
          pinnedContainer: this.container,
          pin: true,
          scrub: true,
          pinSpacing: false,
          anticipatePin: 1,
          fastScrollEnd: true,
          invalidateOnRefresh: true,
          //markers: true,
          id: "card-" + index
        }));
      });
      ScrollTrigger.addEventListener('refreshInit', () => {
        if (this.stackEnabled) {
          this.initCards();
        }
      });
    }
  }
  customElements.define('multi-row', MultiRow);
}
